import React, { useState } from 'react';
import './TalkToFounders.css';

export default function TalkToFoundersModal({ isOpen, onClose }) {
  const [form, setForm] = useState({ name:'', email:'', country:'', message:'' });
  const [status, setStatus] = useState(''); // idle, sending, sent

  if (!isOpen) return null;

  const handleChange = e => setForm({...form, [e.target.name]: e.target.value});

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    const subject = `Enquiry - ${form.name} - ${form.email}`;
    const body = `New Enquiry from Silwren Website:

Name: ${form.name}
Email: ${form.email}
Country: ${form.country}
Message: ${form.message}

---
Sent from silwren.com Talk to Founders form`;

    // OPTION 1: Instant mailto (works now, no backend needed)
    // This opens user's email client with pre-filled mail to contact@silwren.com
    const mailtoLink = `mailto:contact@silwren.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;

    // OPTION 2: If you have backend (uncomment below and comment mailto above)
    /*
    try {
      const res = await fetch('http://localhost:5000/api/send-enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, subject, body })
      });
      if (res.ok) {
        setStatus('sent');
        setTimeout(()=>{ setStatus(''); onClose(); setForm({name:'',email:'',country:'',message:''}); }, 2000);
      } else throw new Error();
    } catch {
      setStatus('idle');
      alert('Failed to send. Please email directly to contact@silwren.com');
    }
    */
   
    // For mailto flow, show sent state
    setTimeout(()=>{ setStatus('sent'); }, 500);
    setTimeout(()=>{ setStatus(''); onClose(); setForm({name:'',email:'',country:'',message:''}); }, 2500);
  };

  return (
    <div className="founders-overlay" onClick={onClose}>
      <div className="founders-modal" onClick={e=>e.stopPropagation()}>
        <div className="founders-header">
          <h3>Talk to Founders</h3>
          <button className="close-x" onClick={onClose}>×</button>
        </div>
        <p className="founders-sub">We usually reply within 24 hours. Tell us what you're building.</p>

        <form onSubmit={handleSubmit} className="founders-form">
          <div className="field">
            <label>Name *</label>
            <input name="name" value={form.name} onChange={handleChange} required placeholder="Vikas Choudhary" />
          </div>
          <div className="field">
            <label>Email ID *</label>
            <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="you@company.com" />
          </div>
          <div className="field">
            <label>Country *</label>
            <select name="country" value={form.country} onChange={handleChange} required>
              <option value="">Select country</option>
              <option>India</option><option>USA</option><option>UK</option><option>Germany</option><option>Singapore</option><option>UAE</option><option>Other</option>
            </select>
          </div>
          <div className="field">
            <label>Message *</label>
            <textarea name="message" value={form.message} onChange={handleChange} required rows="4" placeholder="We are building... looking for..."></textarea>
          </div>

          <div className="founders-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-submit" disabled={status==='sending'}>
              {status==='sending' ? 'Sending...' : status==='sent' ? '✓ Sent!' : 'Submit Enquiry'}
            </button>
          </div>

          <p className="founders-hint">On submit, your email client will open with mail to <b>contact@silwren.com</b><br/>Subject: <code>Enquiry + {form.name || 'Name'} + {form.email || 'Email'}</code></p>
        </form>
      </div>
    </div>
  );
}